import React from 'react';
import PropTypes from 'prop-types';
import { VIEW_SIZE } from 'utils/device';
import styles from './EvergreenShopBanner.module.scss';

const EvergreenShopBanner = ({
  desktopImage,
  tabletImage,
  mobileImage,
  backgroundColor,
  viewSize,
}) => {
  const src = {
    [VIEW_SIZE.xLarge]: desktopImage,
    [VIEW_SIZE.large]: desktopImage,
    [VIEW_SIZE.medium]: tabletImage,
    [VIEW_SIZE.small]: mobileImage,
  };

  const containerStyles =
    viewSize === VIEW_SIZE.small || viewSize === VIEW_SIZE.medium
      ? { backgroundColor }
      : null;

  return (
    <div className={styles.container} style={containerStyles}>
      <img alt="Evergreen shop banner" src={src[viewSize]} />
    </div>
  );
};

EvergreenShopBanner.propTypes = {
  desktopImage: PropTypes.string.isRequired,
  tabletImage: PropTypes.string.isRequired,
  mobileImage: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string.isRequired,
  viewSize: PropTypes.string.isRequired,
};

export default EvergreenShopBanner;
